import classNames from 'classnames';
import { useState, useRef, useEffect, useContext } from 'react';
import { Input } from '@wukong/haomao';
import Select from 'react-select';
import { useTranslation } from 'next-i18next';
import { MyContext } from '../../../../config/context-manager';
import styles from './style.module.scss';

interface CountryCodeItemPops {
  zh_name: string;
  d_code: string;
  en_name: string;
}
interface PhoneInputProps {
  value?: [string, string, string?];
  onChange?(value: [string?, string?, string?]): void;
  placeholder?: string;
  inputClassName?: string;
  countryCodeClassName?: string;
  // arrowClassName?: string;
  countryCode?: CountryCodeItemPops[];
}

const PhoneInput = ({
  value = ['+64', '', ''],
  onChange,
  placeholder = '请输入手机号',
  inputClassName,
  countryCodeClassName,
  // arrowClassName,
  countryCode,
}: PhoneInputProps) => {
  const { t } = useTranslation('chineseMathClass');
  const { locale } = useContext(MyContext);
  const [showPanel, setShowPanel] = useState(false);
  const [innerValue, setValue] = useState<string>();
  const codeItemRef = useRef<Record<string, HTMLDivElement>>({});
  const contentRef = useRef<HTMLDivElement>();

  useEffect(() => {
    if (showPanel && innerValue) {
      codeItemRef.current[innerValue]?.scrollIntoView({ block: 'center' });
    }
  }, [showPanel]);

  useEffect(() => {
    const setMaskOpacity = (e: MouseEvent) => {
      if (e.target !== contentRef.current) {
        setShowPanel(false);
      }
    };
    if (showPanel) {
      window.addEventListener('click', setMaskOpacity);
    }

    return () => {
      window.removeEventListener('click', setMaskOpacity);
    };
  }, [showPanel]);

  useEffect(() => {
    setValue(value[0]);
  }, [value]);
  return (
    <div className={styles.phoneInputWrap}>
      {/* 点击区域 */}
      <div className={classNames(styles.countryCode, countryCodeClassName)}>
        <Select
          placeholder=""
          classNamePrefix="select"
          noOptionsMessage={() => t('下拉选择')}
          value={countryCode?.find(({ d_code }) => d_code === value[0])}
          onChange={(e) => {
            setValue(e?.d_code);
            onChange?.([e?.d_code, value[1], e?.en_name]);
          }}
          formatOptionLabel={(option) => `${option.d_code} ${locale === 'en' ? option.en_name : option.zh_name}`}
          className={styles.select}
          isSearchable
          options={countryCode}
          getOptionValue={(option) => `${option.d_code} ${option.zh_name} ${option.en_name}`}
        />
      </div>

      <Input
        type="tel"
        className={classNames(styles.phoneInput, inputClassName)}
        placeholder={placeholder}
        value={value[1]}
        onChange={(e) => {
          onChange?.([value[0], e.target.value, value?.[2]]);
        }}
        name="phone"
      />
    </div>
  );
};

export default PhoneInput;
